import { all, fork } from 'redux-saga/effects';
import { routinePromiseWatcherSaga } from 'redux-saga-routines';

import reportError from '../shared/utils/reportError';
import watchStartup from './startup/startup.sagas';
import watchContentRegistry from './contentRegistry/contentRegistry.sagas';
import watchMarket from './market/market.sagas';
import watchExperience from './experience/experience.sagas';
import watchKiosk from './kiosk/kiosk.sagas';
import watchHeaderBar from './headerBar/headerBar.sagas';
import watchBooking from './booking/booking.sagas';
import watchAuth from './auth/auth.sagas';
import watchSnackbar from './snackbar/snackbar.sagas';
import watchIdleTimeout from './idleTimeout/idleTimeout.sagas';
import watchOverlay from './overlay/overlay.sagas';
import watchLegal from './legal/legal.sagas';
import watchCancellation from './cancellation/cancellation.sagas';
import watchFilters from './filters/filters.sagas';
import watchFiltered from './filtered/filtered.sagas';
import watchUser from './user/user.sagas';
import watchItinerary from './itinerary/itinerary.sagas';
import watchAnalytics from './analytics/analytics.sagas';
import watchRouter from './router/router.sagas';
//<-- IMPORT MODULE SAGA -->

export default function* rootSaga() {
  try {
    yield all([
      fork(routinePromiseWatcherSaga),
      fork(watchStartup),
      fork(watchContentRegistry),
      fork(watchMarket),
      fork(watchExperience),
      fork(watchKiosk),
      fork(watchHeaderBar),
      fork(watchBooking),
      fork(watchAuth),
      fork(watchSnackbar),
      fork(watchIdleTimeout),
      fork(watchOverlay),
      fork(watchCancellation),
      fork(watchLegal),
      fork(watchFilters),
      fork(watchFiltered),
      fork(watchUser),
      fork(watchItinerary),
      fork(watchAnalytics),
      fork(watchRouter),
      //<-- INJECT MODULE SAGA -->
    ]);
  } catch (e) {
    yield reportError(e);
  }
}
